import React, { forwardRef, Ref } from 'react';
import '../../styles/print-view.css';

interface PrintSchemaV3Props {
  dataPrint: string; // Asumiendo que dataPrint es un string
}

const PrintSchemaV3 = forwardRef((props: PrintSchemaV3Props, ref: Ref<HTMLDivElement>) => {
  const { dataPrint } = props;

  return (
    <div className='container-schema hide-on-print' ref={ref}>
      <div className='header-schema'>
        <div style={{ width: "100%", marginRight: "13px" }} dangerouslySetInnerHTML={{ __html: dataPrint }}>
        </div>
      </div>
    </div>
  );
});

export default PrintSchemaV3;
